import { useEffect, useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { HiPencil } from 'react-icons/hi';
import { Box, Button } from '@mui/material';
import { DataCertificado } from '../../interfaces/Certificados';
import '../Icono/cardIcon.css';
import CertificadoService from '../../services/CertificadoService';
import AlertService from '../../services/AlertService';
import { CasUserContext } from '../../services/casUserContext';
import { string } from 'yup';
import { certificado } from '../../interfaces/Certificados';
import PdfViewer from './PdfViewer';
import { parse } from 'path';

const localBack: string = process.env.REACT_APP_BACK || '';

const certificadoService = new CertificadoService();
const alertaService = new AlertService();


export default function BusquedaCertificado() {
  const casUserContext = useContext(CasUserContext);
  const [busqueda, setBusqueda] = useState('');
  const [certificadoEncontrado, setCertificadoEncontrado] = useState<certificado | null>(null);
  const [existeCertificado, setExisteCertificado] = useState(false)
  const [status, setStatus] = useState(0);
  const [pdfBase64, setPdfBase64] = useState('');
  const [pdfResult, setPdfResult] = useState(false);
  const [rutaArchivo, setRutaArchivo] = useState('')

  const getPdf = (id: number | undefined) => {
    fetch(`${localBack}/api/FileUpload/DescargarEvidencia/${id}`, {
      method: 'GET',
    })
      .then(response => {
        //console.log(response)
        setStatus(response.status);
        return response.json();
      })
      .then(data => {
        if (data !== '') {
          setPdfBase64(`data:application/pdf;base64,${data}`)
          setPdfResult(true);
        } else {
          setPdfResult(false);
        }
      });
  }

  const verificarCertificado = async () => {
    //console.log(busqueda);
    if (busqueda === "") {
      alertaService.alertaAdvertencia("Campo vacío", "Por favor ingrese el código de un certificado a buscar.");
    } else {
      alertaService.showLoading("Buscando Certificado");
      const resp = await certificadoService.BuscarCertificado(busqueda);
      alertaService.hideLoading();
      if (resp.status.isSuccessfully) {
        alertaService.alertaExito("Exito", "Certificado Encontrado");
        setCertificadoEncontrado(resp.data)
        setExisteCertificado(true);
        getPdf(parseInt(resp.data.refarchivo.split(',')[1]))
        setRutaArchivo(resp.data.ruta);

      } else {
        alertaService.alertaAdvertencia("Sin datos", "El certificado no existe");
        setExisteCertificado(false);
      }
    }
  }

  return (
    <Box>
      {/* Primer contenedor: input + botón */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2, // padding equivalente a tu theme.spacing si quieres
        }}
      >
        <div className="text-right">
          <input
            type="text"
            className="p-2 text-gray-600 border border-gray-300 rounded outline-indigo-700"
            placeholder="Código del certificado..."
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>
        <Button size="small" variant="contained" onClick={verificarCertificado}>
          Buscar Certificado
        </Button>
      </Box>

      {/* Segundo contenedor: visor PDF */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh',
          p: 2, // opcional, agrega padding si quieres
        }}
      >
        {existeCertificado && <PdfViewer pdfBase64={pdfBase64} />}
      </Box>
    </Box>
  )
}